import type { UseFormRegister, Path, FieldValues } from 'react-hook-form';

type FormTextareaProps<T extends FieldValues> = {
    name: Path<T>;
    label: string;
    register: UseFormRegister<T>;
    registerOptions?: Parameters<UseFormRegister<T>>[1];
    placeholder?: string;
    rows?: number;
};

export default function FormTextarea<T extends FieldValues>({
    name,
    label,
    register,
    registerOptions,
    placeholder,
    rows = 4
}: FormTextareaProps<T>) {
    return (
        <div className="space-y-3">
            <label className="block text-body-14 font-semibold text-[var(--on-surface-color)]">{label}</label>
            <textarea
                rows={rows}
                {...register(name, registerOptions)}
                className="w-full p-3 border rounded-8 transition-colors focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[var(--focus-ring-color)] border-[rgba(var(--on-surface-color),0.3)] bg-transparent text-[var(--on-surface-color)]"
                placeholder={placeholder}
            />
        </div>
    );
}
